import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDeptTree } from '@/api/system/dept/dept';
import { fetchMeetingRoomList, getStartHour, getEndHour, fetchApplyCreate } from '@/api/PMS/meeting/meeting'; // import { fetchClassList, fetchCreate, fetchDetailForManage } from '@/api/PMS/notice/notice'
// import Tinymce from '@/components/Tinymce'

export default {
  //   components: { Tinymce },
  props: ['id', 'showDialog'],
  data: function data() {
    var _ref;

    return _ref = {
      rules: {
        classList: [{
          required: true,
          message: '请选择通知班次',
          trigger: 'blur'
        }],
        tzry: [{
          required: true,
          message: '请选择通知人员',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入通知标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请输入通知内容',
          trigger: 'blur'
        }, {
          min: 1,
          max: 4000,
          message: '长度在 1 到 4000 个字符',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      files: [],
      listObj: [],
      oldImgList: [],
      removeList: [],
      uploadUrl: '',
      downloadUrl: '',
      addList: [],
      uploadList: [],
      dialogImageUrl: '',
      addPicUrlList: [],
      meetingDate: null,
      deletePicUrl: [],
      picUrl: '',
      toolbar: [''],
      buildingId: ''
    }, _defineProperty(_ref, "uploadUrl", ''), _defineProperty(_ref, "dialogImageUrl", ''), _defineProperty(_ref, "imageUrl", ''), _defineProperty(_ref, "typeRadio", false), _defineProperty(_ref, "dialogVisible", false), _defineProperty(_ref, "dialogPreVisible", false), _defineProperty(_ref, "fileList", []), _defineProperty(_ref, "options", []), _defineProperty(_ref, "cascaderItem", []), _defineProperty(_ref, "buildingOptions", []), _defineProperty(_ref, "listObj", {}), _defineProperty(_ref, "baseAPIPhoto", ''), _defineProperty(_ref, "viewUserList", ''), _defineProperty(_ref, "knowUserList", ''), _defineProperty(_ref, "readonly", 1), _defineProperty(_ref, "deviceList", []), _defineProperty(_ref, "sourceOption", []), _defineProperty(_ref, "OrderOption", []), _defineProperty(_ref, "classOption", []), _defineProperty(_ref, "degreeOption", []), _defineProperty(_ref, "HouseCodeList", []), _defineProperty(_ref, "isDisabled", false), _defineProperty(_ref, "showmatter", true), _defineProperty(_ref, "showClassList", false), _defineProperty(_ref, "childData", {
      title: '',
      content: '',
      isReceipt: '0',
      noticeType: '0',
      receiverObjectType: '1',
      classOption: [],
      classList: []
    }), _defineProperty(_ref, "typeOption", []), _defineProperty(_ref, "documentOption", []), _defineProperty(_ref, "users", []), _defineProperty(_ref, "meetingRoom", ''), _defineProperty(_ref, "meetingRoomOption", []), _defineProperty(_ref, "startHours", []), _defineProperty(_ref, "startHour", ''), _defineProperty(_ref, "endHours", []), _defineProperty(_ref, "endHour", ''), _defineProperty(_ref, "pickerOptions", {
      disabledDate: function disabledDate(time) {
        var _now = new Date(new Date(new Date().toLocaleDateString()).getTime());

        return time.getTime() < _now;
      }
    }), _ref;
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.options = [];
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
    this.baseAPIPhoto = process.env.VUE_APP_UPLOAD;
  },
  methods: {
    getReceiverObjectName: function getReceiverObjectName() {
      var res = '';

      if (this.childData.receiverObjectType === '1') {
        res = '全校教职工';
      } else if (this.childData.receiverObjectType === '2') {
        res = '全校办公人员';
      } else if (this.childData.receiverObjectType === '3') {
        res = '全校教师';
      } else if (this.childData.receiverObjectType === '4') {
        res = '指定班次学员';
      } else if (this.childData.receiverObjectType === '5') {
        res = '全体班主任';
      } else if (this.childData.receiverObjectType === '6') {
        res = '自定义选择人员';
      }

      return res;
    },
    getStr: function getStr(arr) {
      console.log(arr);
      var res = '';

      if (arr === undefined || arr === null || arr.length === 0) {} else {
        arr.forEach(function (item) {
          res = res + item + ',';
        });
      }

      if (res !== '') {
        res = res.substring(0, res.length - 1);
      }

      return res;
    },
    receiverObjectTypeChanged: function receiverObjectTypeChanged() {
      if (this.childData.receiverObjectType === '4') {
        this.showClassList = true;
      } else {
        this.showClassList = false;
      }
    },
    loadClassList: function loadClassList() {
      var _this = this;

      var data = {};
      fetchClassList(data).then(function (response) {
        _this.classOption = response.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.showClassList = false;
      this.loadClassList();
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });

      if (this.id > 0) {
        this.isDisabled = true;
        var queryData = {
          id: this.id
        };
        fetchDetailForManage(queryData).then(function (response) {
          _this2.childData = response.data.data;
          _this2.childData.isReceipt = _this2.childData.isReceipt.toString();
          _this2.childData.noticeType = _this2.childData.noticeType.toString();
          _this2.childData.receiverObjectType = _this2.childData.receiverObjectType.toString();
          _this2.childData.classList = [];

          _this2.childData.userList.forEach(function (item) {
            _this2.childData.classList.push(parseInt(item));
          });

          console.log(_this2.childData.userList);
          _this2.fileList = _this2.childData.fileMsgs;

          _this2.childData.fileMsgs.forEach(function (item) {
            item.name = item.fileName;
          });

          _this2.files = _this2.childData.fileMsgs;

          _this2.receiverObjectTypeChanged();

          var that = _this2;
          setTimeout(function () {
            that.$refs['editor'].setContent(that.childData.content);
          }, 100);
        });
      } else {
        this.isDisabled = false;
        this.childData = {
          title: '',
          content: '',
          isReceipt: '0',
          noticeType: '0',
          receiverObjectType: '1',
          classOption: [],
          classList: []
        };
        var that = this;
        setTimeout(function () {
          that.$refs['editor'].setContent('');
        }, 100);
      }
    },
    changeLocationValue: function changeLocationValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.id === val;
      });
      var getName = '';
      getName = obj.locationName;
      console.log(getName);
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var data = {};
          data.userList = [];

          if (_this3.childData.classList !== null) {
            _this3.childData.classList.forEach(function (item) {
              data.userList.push(item.toString());
            });
          }

          data.title = _this3.childData.title;
          data.content = _this3.childData.content;
          data.isReceipt = parseInt(_this3.childData.isReceipt);
          data.noticeType = parseInt(_this3.childData.noticeType);
          data.receiverObjectType = parseInt(_this3.childData.receiverObjectType); // data.encourageDate = new Date()

          data.isDel = 0;
          data.corpId = 1;
          data.receiverObjectName = _this3.getReceiverObjectName();
          console.log(data.receiverObjectName);
          fetchCreate(data).then(function () {
            _this3.$emit('handDetailCancle', true);

            _this3.Alert({
              alertType: 'add'
            });
          });
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handDetailCancle', 'repairAdd');
    },
    // 表单切换时重置表单内容
    resetForm: function resetForm() {
      this.fileList = [];
      this.isDisabled = false;
      this.loadOrerOptions();
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      var newpic = {
        name: '',
        url: response.data.fileName
      };
      this.fileList.push(newpic);
      this.addPicUrlList.push(response.data.fileName);
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handleExceed: function handleExceed() {// this.$message({
      //     message: '最多只能上传3张图片!',
      //     type: 'warning'
      // })
    },
    handlePreview: function handlePreview(file) {
      console.log(file);

      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.url === undefined) {
          file.url = file.fileId;
        }

        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
          console.log(this.dialogImageUrl);
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
          console.log(this.dialogImageUrl + '   ' + file.name);
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      var extension = testmsg === 'jpg';
      var extension2 = testmsg === 'png';
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!extension && !extension2) {
        this.$message({
          message: '只支持上传文件 JPG/PNG 格式图片!',
          type: 'warning'
        });
        return extension || extension2 && isLt2M;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        });
        return extension || extension2 && isLt2M;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _self = this;

      this.deletePicUrl.push(file.url);
      this.addPicUrlList.forEach(function (item, index) {
        if (item === file.url) {
          _self.addPicUrlList.splice(index, 1);
        }
      });
      this.fileList.forEach(function (item, index) {
        if (item.url === file.url) {
          _self.fileList.splice(index, 1);
        }
      });
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};